<template>
    <div class="pa-3" style="height: 100%">
        <v-card
            class="pa-3"
            style="height: 100%; display: flex; flex-direction: column"
        >
            <v-toolbar flat color="#1d2735" dark style="max-height: 4rem">
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre><v-toolbar-title><h2>Mapa de órdenes</h2></v-toolbar-title></pre>
            </v-toolbar>
            <loader v-if="isloading"></loader>
            <v-row style="max-height: 5rem">
                <v-col cols="12">
                    <v-autocomplete
                        v-model="id_producto"
                        :items="productos"
                        item-text="titulo"
                        item-value="id"
                        label="Producto"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <div style="flex: 1">
                <l-map ref="myMap" style="z-index: 1; height: 100%"> </l-map>
            </div>
        </v-card>
    </div>
</template>
<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
    data() {
        return {
            productos: [],
            id_producto: null,
            map: null,
            markers: null,
            greenIcon: L.icon({
                iconUrl: "/marker-icon.png",
                shadowUrl: "marker-shadow.png",
                iconSize: [24, 40],
                iconAnchor: [12, 40],
            }),
            isloading: false,
        };
    },
    created() {
        this.getProductos();
    },
    watch: {
        id_producto(val) {
            this.isloading = true;
            this.getCoordenadas();
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.map = this.$refs.myMap.mapObject.setView(
                [38.269932, -0.712561],
                13
            );
            L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                maxZoom: 19,
                attribution:
                    '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            }).addTo(this.map);
            this.markers = L.layerGroup().addTo(this.map);

            this.AddMarker(38.269932, -0.712561);
        });
    },
    methods: {
        getCoordenadas() {
            axios.get(`api/get-puntos-mapa/${this.id_producto}`).then(
                (res) => {
                    this.markers.clearLayers();
                    res.data.forEach((element) => {
                        try {
                            if (element.lat != null && element.lon != null) {
                                this.AddMarker(
                                    element.lat,
                                    element.lon,
                                    element.cliente?.codnombre
                                );
                            }
                        } catch (ex) {
                            console.log(element, ex);
                        }
                    });
                    this.isloading = false;
                },
                (res) => {}
            );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        AddMarker(lat, lon, text) {
            L.marker([lat, lon], { icon: this.greenIcon })
                .addTo(this.markers)
                .bindPopup(text);
        },
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
};
</script>
